var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.5625H5C4.6925 9.5625 4.4375 9.3075 4.4375 9C4.4375 8.6925 4.6925 8.4375 5 8.4375H14C14.3075 8.4375 14.5625 8.6925 14.5625 9C14.5625 9.3075 14.3075 9.5625 14 9.5625Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.0625C9.1925 14.0625 8.9375 13.8075 8.9375 13.5V4.5C8.9375 4.1925 9.1925 3.9375 9.5 3.9375C9.8075 3.9375 10.0625 4.1925 10.0625 4.5V13.5C10.0625 13.8075 9.8075 14.0625 9.5 14.0625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a81aec01b9d320a1ef63101c35f9f070.svg";
export { ForwardRef as ReactComponent };